import { Sparkles } from 'lucide-react';
import { PageHeader } from '../components/shell/PageHeader';
import { StrategistChat } from './strategist/StrategistChat';
import { TestModeBanner } from '../features/testMode/TestModeBanner';

/**
 * Content Strategist — the LLM chat assistant. Drafting/editing content now lives
 * in the site-wide Content Composer modal (opened via the `?compose=` search
 * param), so this page is just the chat.
 */
export function StrategistPage() {
  return (
    // The same full-width scroll region as StandardLayout, with the same room for its scrollbar
    // (an empty gutter here, as wide as the track StandardLayout always draws), so
    // this page's column is centered exactly where every other page's is. The column fills it
    // exactly and the chat scrolls inside its own panes, so in any ordinary window the region has
    // nothing to scroll; only a window shorter than the header would.
    <div className="min-h-0 flex-1 overflow-y-auto [scrollbar-gutter:stable]">
      <div className="mx-auto flex h-full w-full min-h-0 max-w-[1440px] flex-col">
        <div className="shrink-0 px-6 pt-6">
          <PageHeader
            title="Content Strategist"
            icon={Sparkles}
            description="Brainstorm with the AI strategist, then draft and refine content."
          />
          <TestModeBanner />
        </div>

        {/* Chat manages its own internal scroll regions; fill the viewport. */}
        <div className="min-h-0 flex-1 px-6 pb-5 pt-1">
          <StrategistChat />
        </div>
      </div>
    </div>
  );
}
